// extracted by mini-css-extract-plugin
module.exports = {"component":"mock-hsq-sticky-headers-component--3iWLg"};